// Bulk operations own only the exclusions they add. Existing/manual exclusions
// and assets outside the active tab are preserved when undoing the batch.
export const bulkExclusions = (
	excluded: number[],
	scope: number[],
	owned: number[],
	check: boolean,
) => {
	const selected = new Set(excluded);
	const group = new Set(scope);
	const bulk = new Set(owned.filter((id) => group.has(id) && selected.has(id)));
	if (check) {
		for (const id of group)
			if (!selected.has(id)) {
				selected.add(id);
				bulk.add(id);
			}
	} else {
		for (const id of bulk) selected.delete(id);
		bulk.clear();
	}
	return { excluded: [...selected], owned: [...bulk] };
};
